import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'

import { success, triggleLogin } from '@api/home/store/slice/loginSlice'
import { routesPath } from '@api/home/utils'
import { Flex, Switch, Text } from '@ui-pc'
import showPopup from '@ui-pc/Popup'

/**
 * 购物车空状态（优惠券面板为空也会引用该组件）
 */

export const ShopEmty = (props) => {
  const {
    text = 'Your shopping cart is empty!',
    onLogin,
    isCard,
    Icon,
    isCoupon
  } = props
  const navigate = useNavigate()

  const dispatch = useDispatch()

  const isLogin = useSelector((state: any) => state.app.isLogin)

  return (
    <div className='shop-cart-empty'>
      <div className='shop-empty-icon'>
        {Icon ? Icon : <i className='iconfont icon-cart2'></i>}
      </div>
      <div className='shop-empty-tip'>{text}</div>
      <Switch either={isCard}>
        <>
          <div>
            {!isLogin && (
              <span className='shop-empty-sign'>
                Shop now or{' '}
                <a
                  onClick={() => {
                    dispatch(triggleLogin(true))
                    dispatch(
                      success(() => {
                        onLogin?.()
                      })
                    )
                  }}
                >
                  SIGN IN
                </a>{' '}
                to check your shopping cart.
              </span>
            )}
          </div>
          <a
            onClick={() => {
              navigate(routesPath.home)
            }}
            className='return-home'
          >
            Return Home
          </a>
        </>
      </Switch>
    </div>
  )
}

export const showEstPoup = () => {
  showPopup({
    // width: '',
    // title: 'Tax Infourmation',
    children: (
      <Flex span='516px' padding={[32]} rowGap={16} justify='center'>
        <Text strong size={20} textAlign='center'>
          Tax Information
        </Text>
        <ul
          style={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: 16,
            fontSize: 16,
            paddingLeft: 12
          }}
        >
          <li style={{ listStyle: 'unset' }}>
            The sales tax for your order is based on state and local tax rates
            as well as the shipping and/or service location of your order.
          </li>
          <li style={{ listStyle: 'unset' }}>
            We will add all applicable taxes to items shipped to CA.
          </li>
          <li style={{ listStyle: 'unset' }}>
            We do not charge sales tax on shipping and handling.
          </li>
        </ul>
      </Flex>
    )
  })
}
